import { oc } from '@orpc/contract'
import { z } from 'zod'

export const taskAttachmentSchema = z.object({
  id: z.string().min(1),
  taskId: z.string().min(1),
  uploadedBy: z.string().min(1),
  filename: z.string(),
  filePath: z.string(),
  fileSize: z.number().int(),
  contentType: z.string(),
  documentId: z.string().nullable().default(null),
  createdAt: z.string(),
})

export const taskAttachmentsListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(taskAttachmentSchema),
    })
  )

export const taskAttachmentsDeleteContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      taskId: z.string().min(1),
      attachmentId: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))
